import React from 'react';

import { Root, Title, Desc, Cta } from './CTASection.style';

export const CTASection = ({
  title = '',
  desc = '',
  ctaText = '',
  ctaUrl = '/',
  accentColor = '#533fa4',
}) => {
  return (
    <Root>
      <Title>{title}</Title>
      <Desc>{desc}</Desc>
      <Cta to={ctaUrl} style={{ backgroundColor: accentColor }}>
        <span>{ctaText}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 16 16"
          width={16}
          height={16}
        >
          <path
            d="m5.683 14.354-1.055-1.058 5.111-5.1v-.389l-5.111-5.1L5.684 1.65l5.55 5.541v1.626Z"
            fill="currentColor"
          />
        </svg>
      </Cta>
    </Root>
  );
};
